import { jsx } from 'react/jsx-runtime';
import { cva } from 'class-variance-authority';
import { useNavigationContext } from '../NavigationContext/NavigationContext.js';

const dividerContainerStyles = cva([
    "mci-flex mci-flex-col mci-gap-xxs",
    "after:mci-content-[''] after:mci-flex after:mci-border-b-0 after:mci-my-xs after:mci-h-[1px] after:mci-bg-gray-300",
], {
    variants: {
        isExpanded: {
            // 8px padding + 20px icon + 16px gap results in 44px from the left
            true: "after:mci-justify-end after:mci-ml-[44px]",
            false: "after:mci-justify-center",
        },
    },
});
const NavigationBarGroup = ({ children, }) => {
    const { isExpanded } = useNavigationContext();
    return (jsx("li", { children: jsx("ul", { className: dividerContainerStyles({ isExpanded }), children: children }) }));
};

export { NavigationBarGroup };
